import React from 'react';

import { cn } from '../../lib/utils';
import {
	LoadingAnimation,
	LoadingAnimationSize,
} from '../loader/LoadingAnimation';

export interface ITableLoadingProps {
	'minHeightPx'?: number;
	'className'?: string;
	'data-testid'?: string;
}

function TableLoading({
	minHeightPx,
	className,
	'data-testid': dataTestId = 'table-loading',
}: Readonly<ITableLoadingProps>) {
	return (
		<div
			className={cn('flex h-fit w-full flex-col items-center p-32', className)}
			style={minHeightPx === undefined ? undefined : { minHeight: minHeightPx }}
			data-testid={dataTestId}
			data-slot="table-loading"
		>
			<LoadingAnimation size={LoadingAnimationSize.Medium} />
		</div>
	);
}

export { TableLoading };
